import styled from 'styled-components'

export const DescriptionWrapper = styled.div(({ theme }) => ({
  paddingBottom: theme.space['24'],
}))

export const QrCodeImage = styled.img(({ theme }) => ({
  display: 'flex',
  margin: `${theme.space['0']} ${theme.space.auto}`,
  maxHeight: '22.4rem',
}))
